/**
 * «15 марта» — день и месяц без года и времени. Нужен там, где дата лишь
 * подписывает происходящее и не должна перетягивать внимание (витрина
 * главного меню: «Запускаем реплей от 15 марта»).
 * @param {string|Date} value
 * @returns {string} пустая строка, если даты нет или она битая
 */
export const formatDayMonth = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('ru-RU', {day: 'numeric', month: 'long'});
};
